import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import {
    Row,
    Col,
} from '@bootstrap-styled/v4';

import SelectProductCheckboxes from '../../forms/form-groups/select-product-checkboxes';

import required from '../../forms/validate';

const SelectProductForm = ({
    selectproduct,
    handleSubmit,
    // pristine,
    submitFailed,
    // dirty,
    invalid,
    // error,
    submitting,
    // result,
}) => (

    <form autoComplete="off" onSubmit={handleSubmit} noValidate>
        <Row>
            <Col xs="12">

                <Field
                    label="Product"
                    id="product"
                    name="product"
                    component={SelectProductCheckboxes}
                    items={[
                        {
                            productstyle: 'blue',
                            title: 'Stand-alone',
                            label: 'Life protection',
                            value: 'Life protection',
                            name: 'life-protection',
                            id: 'life-protection',

                        },
                        {
                            productstyle: 'maroon',
                            title: 'Stand-alone',
                            label: 'Life Essentials',
                            value: 'Life Essentials',
                            name: 'life-essentials',
                            id: 'life-essentials',

                        },
                        {
                            productstyle: 'pink',
                            title: 'Stand-alone',
                            label: 'Critical illness protection',
                            value: 'Critical illness protection',
                            name: 'critical-illness-protection',
                            id: 'critical-illness-protection',

                        },
                        {
                            productstyle: 'green',
                            title: 'Combined',
                            label: 'Life and critical illness protection',
                            value: 'Life and critical illness protection',
                            name: 'life-and-critical-illness-protection',
                            id: 'life-and-critical-illness-protection',

                        },
                        {
                            productstyle: 'oceanblue',
                            title: 'Stand-alone',
                            label: 'Income protection',
                            value: 'Income protection',
                            name: 'income-protection',
                            id: 'income-protection',

                        },
                        {
                            productstyle: 'purple',
                            title: 'Optional',
                            label: "Children's critical illness protection",
                            value: "Children's critical illness protection",
                            name: 'childrens-critical-illness-protection',
                            id: 'childrens-critical-illness-protection',

                        },
                    ]}
                    validate={[required]}
                    autoComplete="off"
                    handleSubmit={handleSubmit}
                />

            </Col>

        </Row>

    </form>
);

SelectProductForm.propTypes = {
    // error: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    // result: PropTypes.object,
    // status: PropTypes.string,
    // pristine: PropTypes.bool,
    // dirty: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    selectproduct: PropTypes.object,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    submitFailed: PropTypes.bool,
    handleSubmit: PropTypes.func,
};

SelectProductForm.defaultProps = {
    selectproduct: {},
    // error: null,
    submitting: false,
    // result: null,
    handleSubmit: () => {},
    // pristine: true,
    // dirty: false,
    submitFailed: false,
    invalid: false,
};
export default reduxForm({
    form: 'SelectProductForm',
    // enableReinitialize: true,
})(SelectProductForm);
